// import React, { useRef } from 'react';
// import SlickSlider from 'react-slick';
// import image1 from '../assets/images/image1.jpeg';
// import image2 from '../assets/images/image2.png';
// import image3 from '../assets/images/image3.jpeg';

// const ImageSlider = () => {
//   const sliderRef = useRef(null);

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//   };

//   const images = [image2, image3, image1];

//   return (
//     <div className="lg:m-5 lg:mt-4 md:mt-4 sm:mt-4 mt-4"> {/* Add 'mt-16' for default small screens */}
//       <div className="w-full relative">
//         <SlickSlider ref={sliderRef} {...settings}>
//           {images.map((image, index) => (
//             <div key={index} className="flex justify-center items-center">
//               <img
//                 src={image}
//                 alt={`Slide ${index + 1}`}
//                 className="w-full h-64 md:h-72 lg:h-96 xl:h-[500px] 2xl:h-[600px] object-cover"
//               />
//             </div>
//           ))}
//         </SlickSlider>
        
//         {/* Custom Navigation Buttons */}
//         <button
//           onClick={() => sliderRef.current.slickPrev()}
//           className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white text-black p-3 rounded-full shadow-md z-10 hover:bg-gray-200 transition duration-200"
//         >
//           &lt;
//         </button>
//         <button
//           onClick={() => sliderRef.current.slickNext()}
//           className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white text-black p-3 rounded-full shadow-md z-10 hover:bg-gray-200 transition duration-200"
//         >
//           &gt;
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ImageSlider;

import React from "react";
import banner from "../assets/images/BannerHome.jpeg";
import { FaHome, FaBuilding, FaHouseUser, FaMapMarker, FaUserTie } from "react-icons/fa";
import "./ImageSlider.css";
import { useNavigate } from "react-router-dom";

const HomeDesktopBanner = () => {
  const navigate=useNavigate()
  return (
    <div className="relative bg-gray-100 ContainerDiv">
      {/* Image as background */}
      <div className="relative">
        <img
          className="w-full h-auto bannerr"
          src={banner}
          alt="home banner"
        />

        {/* Text and content overlay */}
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white">
          {/* Main Heading */}
          <h1 className="text-4xl font-bold text-center md:text-5xl lg:text-6xl mb-6 text-containerh1">
            Designed for Living, Built for You.
          </h1>
          <h2 className="text-xl font-medium text-center md:text-2xl lg:text-3xl text-white mb-6 text-containerh2">
            Discover Your Dream Home with <span className="text-[#59BD95]">Placezio Estate</span> in Lucknow
          </h2>

          {/* Tabs Section */}
          <ul className="flex flex-wrap justify-center gap-5 mb-6">
            <li
              id="resaleHomeTab"
              data-tab="tabSale"
              onClick={()=>{navigate("/Sell-property-in-lucknow")}}
              data-name="Resale"

              className="hover:bg-[#59BD95] w-24 text-center cursor-pointer"
            >
              <button className="tab text-center my-2">
                <FaHome className="text-2xl mx-auto mb-2" />
                <span>Buy <br /> Properties</span>
              </button>
            </li>
            <li
              id="rentalHomeTab"
              data-tab="tabRent"
              data-name="Rent"
              onClick={()=>{navigate("/appartment_for_rent")}}
              className="hover:bg-[#59BD95] w-24 text-center cursor-pointer"
            >
              <button className="tab text-center my-2">
                <FaBuilding className="text-2xl mx-auto mb-2" />
                <span>Flat <br /> Rent</span>
              </button>
            </li>
            <li
              id="pgHomeTab"
              data-tab="tabPg"
              data-name="Pg"
              className="hover:bg-[#59BD95] w-24 text-center cursor-pointer"
              onClick={()=>{navigate("/appartment_for_rent")}}
            >
              <button className="tab text-center my-2">
                <FaHouseUser className="text-2xl mx-auto mb-2" />
                <span>Villa <br /> Rent</span>
              </button>
            </li>

            {/* These items will now be shown on both small and large screens */}
            <li
              id="plotHomeTab"
              data-tab="tabPlot"
              data-name="Plot"
              className="hover:bg-[#59BD95] w-24 text-center cursor-pointer"
             
            >
              <button className="tab text-center my-2">
                <FaMapMarker className="text-2xl mx-auto mb-2" />
                <span>Plot <br /> &amp; Land</span>
              </button>
            </li>
            <li
              id="agentHomeTab"
              data-tab="tabAgent"
              data-name="Agents"
              className="hover:bg-[#59BD95] w-24 text-center cursor-pointer"
              onClick={()=>{navigate("/agent-listing")}}
            >
              <button className="tab text-center my-2">
                <FaUserTie className="text-2xl mx-auto mb-2" />
                <span>Agent<br /> Listing</span>
              </button>
            </li>
          </ul>

          {/* Search Section (commented out, if needed later) */}
          {/* <div className="w-full max-w-3xl">
            <div className="flex flex-wrap items-center justify-center">
              <div className="relative w-full md:flex-1">
                <input
                  className="w-full p-3 border rounded-lg focus:ring focus:ring-blue-300"
                  type="text"
                  placeholder="Search by Locality"
                />
                <button
                  className="absolute right-2 top-2 p-2 bg-blue-500 text-white rounded-full hover:bg-blue-600"
                  onClick={() => console.log("Near me clicked")}
                >
                  Near Me
                </button>
              </div>
              <div className="mt-4 md:mt-0 md:ml-4">
                <button
                  className="p-3 bg-green-500 text-white rounded-lg hover:bg-green-600"
                >
                  Search
                </button>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default HomeDesktopBanner;
